function Items({ tables, setCurrentTable, currentTable }) {
	return (
		<>
			{tables.map((table) => (
				<div
					className={`button-tab ${table === currentTable ? "active" : ""}`}
					onClick={() => setCurrentTable(table)}
				>
					{getHumanReadableName(table)}
				</div>
			))}
		</>
	);
}

const getHumanReadableName = (table) => {
	let name = "";
	switch (table) {
		case "allTests":
			name = "Все анализы";
			break;
		case "pivotTable":
			name = "Сводная таблица";
			break;
		default:
			break;
	}
	return name;
};

export default Items;
